import React from 'react'
import PropTypes from 'prop-types'
import EditableButton from '@v4/components/common/EditableButton'
import CheckIcon from '@material-ui/icons/Check'
import { CircularProgress, IconButton } from '@material-ui/core'
import TrashAlt from '@v4/components/common/FAIcons/Light/TrashAlt'
import clsx from 'clsx'
import DragHandle from '../DragHandle'
import { useOptionButton } from './OptionButton.hooks'

const OptionButton = props => {
	const [
		{
			deleting,
			className,
			classes,
			disabled,
			loading,
			children,
			editable,
			deletable,
			type,
			checked,
			variant,
			draggable,
			autoFocus,
			placeholder,
		},
		{ handleClick, handleChange, handleDelete, handleKeyUp, handleLabelFocus, handleKeyDown },
	] = useOptionButton(props)

	return (
		<EditableButton
			className={clsx(className, classes.root, classes[type])}
			startIcon={
				(draggable && <DragHandle className={classes.dragButton} />) ||
				(checked && <CheckIcon className={classes.checkIcon} />)
			}
			startIconClassName={classes.startIcon}
			variant={variant}
			disabled={disabled}
			onClick={!disabled ? handleClick : undefined}
			loading={loading}
			displayEmpty
			editable={editable}
			onChange={handleChange}
			onKeyUp={handleKeyUp}
			onKeyDown={handleKeyDown}
			onLabelFocus={handleLabelFocus}
			placeholder={placeholder}
			autoFocus={autoFocus}
			endIcon={
				deletable && (
					<IconButton
						disabled={deleting}
						className={classes.deleteButton}
						onClick={handleDelete}
						component="span"
					>
						{deleting ? (
							<CircularProgress size={16} classes={{ circle: classes.deleting }} />
						) : (
							<TrashAlt />
						)}
					</IconButton>
				)
			}
		>
			{children}
		</EditableButton>
	)
}

OptionButton.propTypes = {
	className: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	value: PropTypes.string,
	disabled: PropTypes.bool,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	onDelete: PropTypes.func,
	deletable: PropTypes.bool,
	type: PropTypes.oneOf(['button', 'checkbox']),
	checked: PropTypes.bool,
	draggable: PropTypes.bool,
	placeholder: PropTypes.string,
	autoFocus: PropTypes.bool,
}

OptionButton.defaultProps = {
	onClick: () => {},
	onChange: () => {},
	onDelete: () => {},
	type: 'button',
}

export default OptionButton
